var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEmpty } from 'lodash';
export function mergeColorRecipes(current, additions, uuidMaker) {
    current = current || {};
    additions = additions || {};
    var _additions = Object.keys(additions).reduce(function (acc, key) {
        var newKey = uuidMaker("color-recipe-" + key);
        acc.newColorRecipeIds[key] = newKey;
        acc.colorRecipes[newKey] = additions[key];
        return acc;
    }, {
        colorRecipes: {},
        newColorRecipeIds: {}
    });
    return {
        colorRecipes: __assign({}, current, _additions.colorRecipes),
        newColorRecipeIds: _additions.newColorRecipeIds
    };
}
export function updateChapterColorRecipes(newChapters, newColorRecipeIds) {
    return newChapters.map(function (chapter) {
        // does this chapter have color recipes?
        if (isEmpty(chapter.colorRecipeObjects)) {
            return chapter;
        }
        // for each color recipe key, replace it
        var colorRecipes = Object.keys(chapter.colorRecipeObjects).reduce(function (acc, key) {
            var newKey = newColorRecipeIds[key];
            acc[newKey] = chapter.colorRecipeObjects[key];
            return acc;
        }, {});
        chapter.colorRecipeObjects = colorRecipes;
        return chapter;
    });
}
